/* eslint-disable @typescript-eslint/no-unsafe-call */
import { put, takeLatest } from "redux-saga/effects";
import { call, select } from "typed-redux-saga";
import { AuthenticatedUserType, Error, LoginUserType } from "../types";
import url from "../api";
import { getCurrentLocale } from "../utils";
import {
  doAuthenticateUserStart,
  doLoginUserDone,
  doLoginUserError,
} from "../actions/general";

import { LOGIN_PROCESS } from "../constants/actionTypes";
import { FETCH_PROFILE } from "../constants/actionTypesTpos";
import { isUserAuthenticated } from "../selectors/user";
import { makeApiCall, setLocale } from "./general";

export default function* authSaga(): Generator {
  yield takeLatest<any>(LOGIN_PROCESS, loginProcess);
  yield takeLatest<any>(FETCH_PROFILE, fetchProfile);
}

type LoginResult = AuthenticatedUserType & Error;
type LoginProcessParams = {
  payload: LoginUserType;
};

// This should be the async process that handles login
export function* loginProcess({
  payload: session,
}: LoginProcessParams): Generator {
  const { login } = url;
  yield put(doAuthenticateUserStart());
  const data: LoginResult = yield* call(makeApiCall, login, {
    session,
  });
  if (data.message || data.errors) {
    yield put(doLoginUserError(data));
  } else if (data) {
    const currentLocale = getCurrentLocale();
    const userPreferredLocale = data.preferredLocale;
    if (userPreferredLocale && currentLocale !== userPreferredLocale) {
      yield setLocale(userPreferredLocale);
    }
    yield put(doLoginUserDone(data));
    // rakesh@thoughtbot.com
    // TODO: Uncomment the following lines to fetch products and config after login
    // yield put(doFetchProducts({ forceUpdate: true }));
    // yield put(doFetchConfig());
  }
}

export function* fetchProfile(): Generator {
  const userAuthToken = yield* select(isUserAuthenticated);
  const { me } = url;
  const data: LoginResult = yield* call(makeApiCall, me, null, {
    headers: {
      "ALBAIK-Auth-Token": userAuthToken,
    },
  });
  if (data.message || data.errors) {
    yield put(doLoginUserError(data));
  } else if (data) {
    const currentLocale = getCurrentLocale();
    const userPreferredLocale = data.preferredLocale;
    if (userPreferredLocale && currentLocale !== userPreferredLocale) {
      yield setLocale(userPreferredLocale);
    }
    yield put(doLoginUserDone(data));
  }
}
